import { api } from "@/shared/api/axios";
import { unwrap } from "@/shared/api/unwrap";
import type { ApiResponse } from "@/shared/api/types";
import type { HelpScope } from "@fysaro/shared";

export interface ConsumerHelpArticleDto {
  id: string;
  key: string;
  title: string;
  content: string;
  youtubeVideoId?: string | null;
  youtubeVideoIdDark?: string | null;
  isFeatured: boolean;
  keywords: string[];
}

export interface ConsumerHelpCategoryDto {
  id: string;
  key: string;
  name: string;
  description?: string | null;
  icon?: string | null;
  articles: ConsumerHelpArticleDto[];
}

const PUBLIC_SCOPES: readonly HelpScope[] = [
  "PUBLIC",
  "PUBLIC_CLINIC",
  "PUBLIC_PATIENT",
];

export const getHelpArticleTreeByScope = async (params: {
  scope: HelpScope;
  language: string;
}): Promise<ConsumerHelpCategoryDto[]> => {
  const endpoint = PUBLIC_SCOPES.includes(params.scope)
    ? "/help-articles/tree"
    : "/help-articles/tree/authenticated";
  const response = await api.get<ApiResponse<ConsumerHelpCategoryDto[]>>(endpoint, {
    params,
  });
  return unwrap(response.data);
};
